import type { GridColumnGroupingModel } from '@repo/go-table';
import { useMemo } from 'react';

import { TableHeader } from '../components/TableHeader/TableHeader';

import { RECOMMENDATION_MULTILINE_TEXT_FIELDS } from './constants';
import { FIELD_TO_RECOMMENDATION_COLUMN_TITLE_KEY } from './FIELD_TO_RECOMMENDATION_COLUMN_TITLE_KEY';

export const AUTO_ANOMALIES_COLUMN_GROUPS = [
  {
    groupId: 'sourceOption',
    children: ['dataType', 'paramValue'],
  },
  {
    groupId: 'userRecommendation',
    children: RECOMMENDATION_MULTILINE_TEXT_FIELDS,
  },
] as const;

export const AUTO_ANOMALIES_GROUPED_COLUMN_FIELDS = new Set<string>(
  AUTO_ANOMALIES_COLUMN_GROUPS.flatMap((group) => group.children),
);

export const useColumnGroups = () => {
  return useMemo(
    (): GridColumnGroupingModel => [
      {
        groupId: AUTO_ANOMALIES_COLUMN_GROUPS[0].groupId,
        children: AUTO_ANOMALIES_COLUMN_GROUPS[0].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'anomalyTypeGroup'}
              textTKey={FIELD_TO_RECOMMENDATION_COLUMN_TITLE_KEY['sourceOption']}
            />
          );
        },
      },
      {
        groupId: AUTO_ANOMALIES_COLUMN_GROUPS[1].groupId,
        children: AUTO_ANOMALIES_COLUMN_GROUPS[1].children.map((field) => ({ field })),
        renderHeaderGroup() {
          return (
            <TableHeader
              field={'userRecommendation'}
              textTKey={FIELD_TO_RECOMMENDATION_COLUMN_TITLE_KEY['userRecommendation']}
            />
          );
        },
      },
    ],
    [],
  );
};
